export default __webpack_public_path__ + "static/media/Dev3.93881364.svg";